if (!window.Eurus.loadedScript.has("product-tabs-mio.js")) {
  window.Eurus.loadedScript.add("product-tabs-mio.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductTabsMio", () => ({
        open: 0,
        tabActive: '',
        transitioning: false,
        init() {
          this.$nextTick(() => {
            const first = this.$el.querySelector('[data-tabtitle]');
            if (first) this.tabActive = first.dataset.tabtitle;
          });
        },
        switchTab(index) {
          if (this.open === index || this.transitioning) return;
          this.transitioning = true;
          this.open = index;
          this.tabActive = this.$el.querySelector(`.tab-item-mio[data-index="${index}"]`)?.dataset.tabtitle || '';
          setTimeout(() => { this.transitioning = false; }, 350);
        }
      }));
    });
  });
}
